import { put, takeEvery, select } from 'redux-saga/effects';
import { BOOKINGTYPES_LOADING, GET_BOOKINGTYPES_DATA_SUCCESS, GET_BOOKINGTYPES_DATA_ERROR } from "../actions/actionBookingTypes";
import { apiBookingTypes } from 'api';

async function fetchAsync(func, id, isDisplayArea) {
  const response = await func(id, isDisplayArea);
  if (response.ok && response.status == 200) {
    return await response.json();
  }
  else if (response.statusText === 'Unauthorized') {
    throw new Error("Authorization has been denied for this request.");
  }
  else if (response.status == 204) {
    return "nocontent";
  }
  if (response.status == 400) {
    let error = await response.json();
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
  }
  else {
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get booking types, response status: " + response.status + "\"}]}")
  }
}

function* fetchBookingTypesData(action) {
  try {

    const events = yield select(state => state.reducerShopCart.events);

    const data = yield fetchAsync(apiBookingTypes, action.id, action.isDisplay);
    yield put({ type: GET_BOOKINGTYPES_DATA_SUCCESS, payload: data, events: events });
  } catch (e) {
    yield put({ type: GET_BOOKINGTYPES_DATA_ERROR, error: e.Errors[0].ErrorMessage });
  }
}

export const sagaBookingTypes = [
  takeEvery(BOOKINGTYPES_LOADING, fetchBookingTypesData)
];
